import { Controller } from '@hotwired/stimulus';

/** Post-save nudge on tool edit: scroll to email section or dismiss. */
export default class extends Controller {
  openEmailSection() {
    const section = document.getElementById('product-section-people');
    if (!section) return;

    section.classList.add('is-highlighted');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const subject = section.querySelector('input[name="subject"]');
    subject?.focus();

    this.dismiss();
  }

  dismiss() {
    this.element.remove();
  }
}
